import { createSelector } from 'reselect';

import { selectRequestUrl } from '../settings/selectors';

export const selectIsMobileView = createSelector(
  selectRequestUrl,
  (requestUrl) => !!requestUrl?.split('?')[1]?.includes('webview'),
);

export const selectIsMainPage = createSelector(
  selectRequestUrl,
  (requestUrl) => new URL(requestUrl).pathname === '/shop/',
);
